import { FieldTemplateDTO } from '../dto';
import { Charsets } from './AssortmentConfig';

interface FieldTemplateProps {
  name: string;
  displayName: string;
  writeAsCsv: boolean;
  vilmaVersion?: 'VILMA_27' | 'VILMA_28';
  charset?: Charsets;
  sftpDirectory?: string;
  numberOfFutureDays?: number;
  totalfilPerSupplier?: boolean;
}

export class FieldTemplate {
  name: string;
  displayName: string;
  writeAsCsv: boolean;
  vilmaVersion?: 'VILMA_27' | 'VILMA_28';
  charset?: Charsets;
  sftpDirectory?: string;
  numberOfFutureDays?: number;
  totalfilPerSupplier?: boolean;

  constructor({
    name,
    displayName,
    writeAsCsv,
    vilmaVersion,
    charset,
    sftpDirectory,
    numberOfFutureDays,
    totalfilPerSupplier,
  }: FieldTemplateProps) {
    this.name = name;
    this.displayName = displayName;
    this.writeAsCsv = writeAsCsv;
    this.vilmaVersion = vilmaVersion;
    this.charset = charset;
    this.sftpDirectory = sftpDirectory;
    this.numberOfFutureDays = numberOfFutureDays;
    this.totalfilPerSupplier = totalfilPerSupplier;
  }

  static fromDto = (dto: FieldTemplateDTO): FieldTemplate =>
    new FieldTemplate({
      name: dto.name,
      displayName: dto.displayName,
      writeAsCsv: dto.writeAsCsv,
      vilmaVersion: dto.vilmaVersion,
      charset: dto.charset as Charsets | undefined,
      sftpDirectory: dto.sftpDirectory,
      numberOfFutureDays: dto.numberOfFutureDays,
      totalfilPerSupplier: dto.totalfilPerSupplier,
    });
}
